import { Colors } from '@/core/components/docs/component-docs/colors'
import { Avatar } from '@/core/components/avatar'
import { LoadingEllipsis } from '@/core/components/loading-ellipsis'
import { TextInput } from '@/core/components/form/base/text-input'
import { TextArea } from '@/core/components/form/base/text-area'
import { Field } from '@/core/components/form/base/field'
import { Typeahead } from '@/core/components/typeahead'
import { TypeaheadStatic } from '@/core/components/typeahead/typeahead-static'
import { FormError } from '@/core/components/form/error'
import { ErrorDetail } from '@/core/components/error-detail'
import { UserList } from '@/core/components/auth/user-list'
import { LoginForm } from '@/core/components/auth/login-form'
import { LoginPage } from '@/core/components/auth/login-page'

export const documentedComponents = {
  Avatar,
  Colors,
  LoadingEllipsis,
  TextInput,
  TextArea,
  Field,
  Typeahead,
  TypeaheadStatic,
  FormError,
  ErrorDetail,
  UserList,
  LoginPage,
}
